module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Card', [_c('p', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("\n        Kontra Print Status\n    ")]), _vm._v(" "), _c('Row', {
    staticClass: "code-row-bg",
    attrs: {
      "type": "flex",
      "justify": "space-between"
    }
  }, [_c('Col', {
    attrs: {
      "span": "4"
    }
  }, [_c('Date-picker', {
    attrs: {
      "type": "date",
      "placeholder": "Tgl.Buat",
      "format": "dd/MM/yyyy"
    },
    model: {
      value: (_vm.searchCreatedDate),
      callback: function($$v) {
        _vm.searchCreatedDate = $$v
      },
      expression: "searchCreatedDate"
    }
  })], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "4"
    }
  }, [_c('Select', {
    attrs: {
      "clearable": "",
      "placeholder": "Dept. Item"
    },
    model: {
      value: (_vm.searchSelectDepartement),
      callback: function($$v) {
        _vm.searchSelectDepartement = $$v
      },
      expression: "searchSelectDepartement"
    }
  }, _vm._l((_vm.departements), function(dept, idx) {
    return _c('Option', {
      key: idx,
      attrs: {
        "value": dept.id
      }
    }, [_vm._v("\n                  " + _vm._s(dept.deptName) + "\n              ")])
  }), 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "2"
    }
  }, [(_vm.searchSelectSubbranch == 'JKT') ? _c('Select', {
    attrs: {
      "clearable": "",
      "placeholder": "Branchcode"
    },
    on: {
      "on-change": _vm.setMarkingCode
    },
    model: {
      value: (_vm.searchSelectSubbranch),
      callback: function($$v) {
        _vm.searchSelectSubbranch = $$v
      },
      expression: "searchSelectSubbranch"
    }
  }, _vm._l((_vm.subbranchs), function(subbranch, idx) {
    return _c('Option', {
      key: idx,
      attrs: {
        "value": subbranch.subbranchcode
      }
    }, [_vm._v("\n                  " + _vm._s(subbranch.subbranchname) + "\n              ")])
  }), 1) : _c('Select', {
    attrs: {
      "placeholder": "Branchcode"
    },
    on: {
      "on-change": _vm.setMarkingCode
    },
    model: {
      value: (_vm.searchSelectSubbranch),
      callback: function($$v) {
        _vm.searchSelectSubbranch = $$v
      },
      expression: "searchSelectSubbranch"
    }
  }, _vm._l((_vm.subbranchs), function(subbranch, idx) {
    return _c('Option', {
      key: idx,
      attrs: {
        "value": subbranch.subbranchcode
      }
    }, [_vm._v("\n                  " + _vm._s(subbranch.subbranchname) + "\n              ")])
  }), 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "4"
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "Ketik Marking",
      "filterable": "",
      "clearable": "",
      "remote": "",
      "remote-method": _vm.getMarkingByCode,
      "loading": _vm.loadingGetMarking
    },
    model: {
      value: (_vm.searchMarkingId),
      callback: function($$v) {
        _vm.searchMarkingId = $$v
      },
      expression: "searchMarkingId"
    }
  }, _vm._l((_vm.searchOptionMarkings), function(option) {
    return _c('Option', {
      key: new Date(),
      attrs: {
        "value": option.value
      }
    }, [_vm._v(_vm._s(option.label))])
  }), 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "4"
    }
  }, [_vm._v("\n          Filter "), _c('Input-number', {
    attrs: {
      "max": 500,
      "min": 1
    },
    model: {
      value: (_vm.filterResult),
      callback: function($$v) {
        _vm.filterResult = $$v
      },
      expression: "filterResult"
    }
  })], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "4"
    }
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.loadingGetReadyPrint,
      "icon": "ios-search-strong"
    },
    on: {
      "click": _vm.getReadyPrint
    }
  }, [(!_vm.loadingGetReadyPrint) ? _c('span', [_vm._v("Cari")]) : _c('span', [_vm._v("Wait.")])])], 1)], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('Alert', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.kontras.length > 0),
      expression: "kontras.length > 0"
    }],
    attrs: {
      "type": "success"
    }
  }, [_vm._v("Showing " + _vm._s(_vm.kontrasToShow.length) + " from " + _vm._s(_vm.kontras.length) + " Marking - Printer Location : " + _vm._s(_vm.printerServerIP))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('Table', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.kontras.length > 0),
      expression: "kontras.length > 0"
    }],
    attrs: {
      "columns": _vm.tableColumn,
      "data": _vm.kontrasToShow,
      "no-data-text": ""
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d5ccb38e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/kontra/KontraIsPrint.vue
// module id = 1853
// module chunks = 1